module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "inline",
      "src": "images/line4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para-top"
  }, [_vm._v("I would like to thank first and foremost, my lovely wife, Clare West, mother of my eight (soon to be nine!) children, provider of my wonderful life, and my best friend, as well as my entire family for their support over the years as I discovered my calling and Higher Purpose in life! I would also like to thank my editor and fellow coach Rachelle Triay, without whom this book would not be where it is today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I would also like to thank all the people who were sources of inspiration and values, including Pastor Ralph Fletcher, Father Jim Curran, Napoleon Hill, Bruce Wilkinson, Andy Andrews, John C. Maxwell, Ken Blanchard, Anthony Robbins, Dr. Joseph Murphy, Dr. W Edwards Deming, Shane and Dannene Perry of Primerica Financial Services, and many others not mentioned here.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 78
// module chunks = 0